import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'

interface GuestGuardProps {
  redirectTo?: string
  children?: React.ReactNode
}

export function GuestGuard({ redirectTo = '/', children }: GuestGuardProps) {
  const { status, step } = useAuth()
  const location = useLocation()

  if (status === 'idle') {
    return null
  }

  if (status === 'authenticated' && step === 'profile_completion') {
    return <Navigate to="/onboarding/owner" replace />
  }

  // Allow OTP/forgot-password steps even while technically "unauthenticated"
  if (status === 'authenticated' && step === 'idle') {
    const from = (location.state as { from?: string })?.from || redirectTo
    return <Navigate to={from} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
